import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { ui } from '../../../../../../../interfaces/interfaces';
import { DialogContent, DialogContentText, Paper, Autocomplete, TextField, Button, DialogActions } from '@mui/material';
import { cacheUtils } from '../../../../../../..';
import { CacheTypes } from '../../../../../../../utilities/cache/interfaces';
import { useAppSelector } from "@store/hooks";

const OTHER_PHONE_ID_FOR_TEAM_LEADER = 55;

const handleClose = () => {
    ui.FailDialogModal = false
};

const handleNoChoice = () => {
    ui.ProblemMsg = "Please select a reason for the fail."
    ui.ProblemMsgVariant = "error"
    ui.ProblemShowMsg = true
};

const handleListItemClick = (value: CacheTypes.OtherPhoneCalls) => {
    handleClose();
    ui.FailFeedbackApplianceIssue = value.otherPhoneCall === 'Appliance Problem'
    ui.FailFeedbackDialogModal = true
    ui.FailFeedbackReason = value
};

type Props = {}

const FailDialog: React.FC<Props> = () => {
    const failDialogModal = useAppSelector(({ ui }) => ui.FailDialogModal);
    const activeStep = useAppSelector(({ ui }) => ui.ActiveStep);
    const [reasons, setReasons] = React.useState<CacheTypes.OtherPhoneCalls[]>([]);
    const [reason, setReason] = React.useState<CacheTypes.OtherPhoneCalls | null>(null);

    React.useEffect(() => {
        if (activeStep === 0 && failDialogModal) {
            setReasons(cacheUtils.getCache<CacheTypes.OtherPhoneCalls>("OtherPhoneCalls").filter((reason) => reason.enabled === true).sort((a, b) => {
                if (a.otherPhoneCall < b.otherPhoneCall) { return -1; }
                if (a.otherPhoneCall > b.otherPhoneCall) { return 1; }
                return 0
            })
                .filter((reason) => Number(reason.otherPhoneId) !== OTHER_PHONE_ID_FOR_TEAM_LEADER)); // Team leader fail reason is not allowed for the first step
        }
    }, [activeStep, failDialogModal]);

    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={failDialogModal}>
            <DialogTitle id="simple-dialog-title">Select fail reason</DialogTitle>
            <DialogContent dividers>
                <DialogContentText>Select valid fail reason and click save or cancel to continue with call.</DialogContentText>
                <Paper elevation={4}>
                    {reasons?.length > 0 && (
                        <Autocomplete
                            id="combo-box-reasons"
                            options={reasons}
                            getOptionLabel={reasons => reasons.otherPhoneCall}
                            onChange={(e, v) => setReason(v as CacheTypes.OtherPhoneCalls)}
                            isOptionEqualToValue={reasons => reasons.otherPhoneId === (reason?.otherPhoneId || 0)}
                            value={reason || null}
                            renderInput={(params) => <TextField {...params} label="Failure reasons list" variant="outlined" error={reason === undefined} />}
                            sx={{ mt: 2 }}
                        />
                    )}
                </Paper >
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={handleClose} color="secondary">
                    Cancel
                </Button>
                <Button variant='contained' onClick={() => reason ? handleListItemClick(reason) : handleNoChoice()} color="success">
                    Feedback
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default React.memo(FailDialog);